import React from 'react';
import StageList from '../components/StageManagement/StageList';

const StageManagement = () => {
  return (
    <div className="min-w-0 max-w-full overflow-x-hidden bg-light-bg-secondary dark:bg-dark-bg-primary">
      <title>Stages | Talent Service</title>
      <StageList />
    </div>
  );
};

export default StageManagement;
